import {ChangeDetectionStrategy, Component} from "@angular/core";


@Component({
    selector: 'inline-skjema-blokk',
    template: '<ng-content/>',
    styleUrls: ['./inline-skjema-blokk.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InlineSkjemaBlokkKomponent {

}
